import { Box } from '@shared/components/box'
import InvestorIcon from '@shared/svg/investor.svg'
import PortfelIcon from '@shared/svg/portfel.svg'
import { Article } from 'screens/about/sections/long-history/article'
import { videos } from 'screens/about/sections/long-history/tabs/2023/data'
import { VideoGrid } from 'screens/about/sections/long-history/video-grid'

import styles from './styles.module.scss'

export const View = () => {
	return (
		<Article>
			<div className={styles.section}>
				<div>
					<h3>
						Оптимизировали процессы по&nbsp;работе с&nbsp;клиентами, чтобы сделать их ещё удобнее
					</h3>
					<Box type='blue'>
						Упрощать доступ клиентам к&nbsp;финансовым услугам — одна из&nbsp;главных наших
						стратегических целей. Из года в&nbsp;год мы стараемся внедрить новые полезные
						возможности, которые позволят сделать клиентский путь ещё проще и&nbsp;комфортнее.
					</Box>
					<p>В 2023 году в рамках стратегической цели мы продолжили оптимизировать процессы:</p>
					<ol>
						<li>
							Чтобы ускорить процедуру кредитования клиентов, мы провели интеграцию с кол-центром.
							Он помогает исключить неактуальные заявки. Это позволяет нашим менеджерам
							сконцентрироваться только на заинтересованных клиентах и ещё быстрее приводить их к
							финальному этапу выдачи денег: подписанию договора.
						</li>
						<li>
							Также для ускорения работы с клиентами мы разработали рекомендательный сервис, который
							позволяет автоматически предоставлять потенциальному заёмщику рекомендации,
							необходимые для выхода на сделку в рамках требований по доходам.
						</li>
						<li>
							Чтобы ускорить проведения платежей внутри инвестиционного направления, мы
							автоматизировали большую часть бухгалтерских операций.
						</li>
						<li>
							Чтобы клиентам было ещё удобнее пользоваться нашими продуктами, мы обновили приложение
							«Credit.Club Деньги».
						</li>
					</ol>
				</div>
				<div>
					<h3>Продолжали развивать платформу цифровых решений</h3>
					<p>
						Инфраструктура нашей платформы помогает кредиторам масштабировать бизнес без увеличения
						штата, открытия офисов и дополнительных инвестиций. В 2023 году мы подключили к
						платформе несколько финансовых организаций и занимались улучшением процессов по
						разработке совместных методик, кредитных программ, а также интеграцией информационной
						системы Credit.Club с учётными системами кредиторов. 
					</p>
					<p>
						<a href='https://creditclub.tech/' target='_blank' className={styles.link} rel="noreferrer">
							Почитать больше про платформу цифровых решений Credit.Club
						</a>
					</p>
					<Box type='green'>
						<p>
							Также, чтобы приблизиться к стратегической цели по упрощению доступа к услугам в целом
							на финансовом рынке, мы продолжали делиться опытом с кредиторами. Например,
							подготовили аналитическую статью о том, как повлияют на финансовый рынок введённые
							макропруденциальные лимиты и почему нововведения должны стать стимулом для банков
							автоматизировать залоговое кредитование.
						</p>
						<p>Материал опубликовали на сайте «Ассоциации Российский банков».</p>
						<a
							href='https://arb.ru/banks/analitycs/vvedennye_makroprudentsialnye_limity_stimul_dlya_bankov_avtomatizirovat_zalogovo-10605206/'
							target='_blank'
							className={styles.link} rel="noreferrer"
						>
							Перейти к статье  →
						</a>
					</Box>
				</div>
			</div>
			<div className={styles.section}>
				<div>
					<h3>Масштабировали инвестиционное направления</h3>
					<p>
						Мы хотели сделать так, чтобы о нашем продукте узнало как можно больше людей, поэтому
						начали сотрудничать с разными площадками, агрегаторами и крупнейшими блогерами. Вот
						небольшая часть активностей, которые помогли масштабировать наше направление:
					</p>
				</div>
				<div className={styles.cards}>
					<Box>
						<div className={styles.iconWrapper}>
							<PortfelIcon />
						</div>
						Размер портфеля «Сбережений» увеличился за год на 162%
					</Box>
					<Box>
						<div className={styles.iconWrapper}>
							<InvestorIcon />
						</div>
						Количество сберегателей за год увеличилось на 221%
					</Box>
				</div>
			</div>
			<VideoGrid videos={videos} />
		</Article>
	)
}
